<span [ngClass]="{'is-late': isLate}">
  {{datetimeStr}}
</span>
